import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailers-rotating_top_banner-view';

/**
 * Event when rotating top banner is viewed. Params contain name of banner
 */
export function trackRetailersRotatingTopBannerView(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    parameters: { customParameterToken },
  });
}
